import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/home/clients.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/home/innovation-card-desc.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/home/team-carousel.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/home/testimonials.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/legacy/image.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
